import * as Yup from 'yup';

const requiredText = () => Yup.string().trim().required('Required');

export const medicalInsuredsValidationSchema = (isTravel = false) => {
  return Yup.object().shape({
    medicalInsureds: Yup.array().of(
      Yup.object().shape({
        insuredID: requiredText(),
        relation: requiredText(),
        passportNumber: isTravel ? requiredText() : Yup.string().nullable(),
        addressID: Yup.string().when('isPrincipal', {
          is: () => true,
          then: () => requiredText(),
          otherwise: (schema) => schema.notRequired().nullable()
        }),
        personType: Yup.string(),
        dateOfBirth: Yup.string().when('personType', {
          is: 'INDIVIDUAL',
          then: () => requiredText(),
          otherwise: (schema) => schema.notRequired().nullable()
        })
      })
    )
  });
};
